export const PAYMENT_AMOUNT_PRECISION = 2;
export const DEFAULT_TRANSACTION_FEE = 0.08;
